export const html = `<div data-myon-attr-class="controlBand card -n{{ itemsPerPage }} {{ modifierClass }}" role="region" aria-labelledby="{{ titleId }} {{ selectId? }}">
	<div class="card_header -control flex -center -gutter -row">
		<h2 class="card_title flex_item" id="{{ titleId }}">{{ title @noescape }}</h2>
		<button data-myon-name="tooltipButton" data-myon-if="{{ showTooltip }}" class="link" aria-hidden="false"><i class="link_icon mycon -info-dot"></i></button>
		<span class="flex_item -grow">
			<select data-myon-name="select" id="{{ selectId }}" class="select" aria-labelledby="{{ titleId }}" data-myon-if="{{ selectId }}" data-myon-on-change="handleSelectChange">
				<option data-myon-template="selectOptions" value="{{ value }}">{{ text }}</option>
			</select>
		</span>
		<div class="flex_item">
			<button aria-label="{{ nextButtonLabel }}" type="button" data-myon-attr-class="button -compact controlBand_more {{ isTransitioning? | '-checked' }}" data-myon-if="{{ overflows }}" data-myon-prop-disabled="{{ isTransitioning }}" data-myon-on-click="handleNextButtonClick">
				<i class="button_icon more-icon mycon -next-in-set"></i>
			</button>
		</div>
	</div>
	<div class="controlBand_empty" data-myon-if="{{ empty }}">
		{{ emptyMessage }}
	</div>
	<div data-myon-attr-class="controlBand_controls {{ isLoading? | '-loading' }} {{ isTransitioning? | '-transitioning' }}" data-myon-if="{{ !empty }}">
		<div class="controlBand_overflow" data-myon-name="overflow">
			<ul class="controlBand_batches" data-myon-hook-remove="handleRemovePage" data-myon-template="pages">
				<li class="controlBand_control" data-myon-template="controls">
					{{ control.element @noescape }}
				</li>
			</ul>
		</div>
	</div>
</div>`;
